import { useTranslation } from 'react-i18next';

import { breakpoints } from '@pulse-web-ui/theme';

import type { Profile } from '@entities/agent-contract';

import { useIsDesktop } from '@shared/hooks';
import { Section } from '@shared/index';

import {
  useGetPersonalData,
  useGetProfileSectionHeaderStyles,
} from '../../hooks';
import type { AgentProfileSectionProps } from '../../model';
import { getPersonalDataTranslations } from '../../utils';

interface PersonalDataSectionProps extends AgentProfileSectionProps {
  profile?: Profile;
  compareProfile?: Profile;
}

export const PersonalDataSection = ({
  profile,
  compareProfile,
  isSubmitSection,
  buttonProps,
}: PersonalDataSectionProps) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop(breakpoints.DESKTOP);
  const dataLabels = getPersonalDataTranslations(t);

  const data = useGetPersonalData(profile);
  const dataToCompare =
    compareProfile && Object.keys(compareProfile).length
      ? useGetPersonalData(compareProfile)
      : undefined;

  const header = useGetProfileSectionHeaderStyles({
    title: t('AGENT_PROFILE:headers.personalData'),
    isDesktop,
    isSubmitSection,
    buttonProps,
  });

  return (
    <Section
      data={data}
      dataToCompare={dataToCompare}
      dataLabels={dataLabels}
      header={header}
    />
  );
};
